<template>

    <!-- Training -->
    <div class="card card--default">

        <!-- Tag -->
        <div class="mb-4">
            
            <!-- If Completed -->
            <span v-if="trainingStore.Sklopi[sklopIndex!].Successful" class="tag tag--completed">Opravljeno</span>
            
            <!-- IF obligatory -->
            <span v-else-if="trainingStore.Sklopi[sklopIndex!].IsObligatory" class="tag tag--mandatory">Obvezno</span>
            <!-- complete date:
            {{ trainingStore.Sklopi[sklopIndex!].DateCompleted }}
            <pre>{{ trainingStore.Sklopi[sklopIndex!] }}</pre> -->
                    
        </div>

        <!-- Heading -->
        <div class="subsection-heading mt-0 mb-4">{{ trainingStore.Sklopi[sklopIndex!].Name }}</div>

        <!-- Description -->
        <div class="">{{ trainingStore.Sklopi[sklopIndex!].Description }}</div>

        <div class="d-flex justify-space-between align-center mt-8">

            <!-- Btn -->
            <!-- <v-btn v-if="trainingStore.Sklopi[sklopIndex!].ZakljucenihVprasanj == 0 && !(trainingStore.Sklopi[sklopIndex!].DateCompleted || trainingStore.Sklopi[sklopIndex!].Successful)" :disabled="trainingStore.Sklopi[sklopIndex!].DateCompleted != null || trainingStore.Sklopi[sklopIndex!].Successful"
            class="btn btn--primary-fill" @click="$emit('change', sklopIndex)">Opravi</v-btn> -->
            <v-btn v-if="trainingStore.Sklopi[sklopIndex!].ZakljucenihVprasanj == 0"
                :disabled="trainingStore.Sklopi[sklopIndex!].DateCompleted != null || trainingStore.Sklopi[sklopIndex!].Successful"
                class="btn btn--primary-fill" @click="$emit('change', sklopIndex)">Opravi</v-btn>
                
            <v-btn v-if="trainingStore.Sklopi[sklopIndex!].ZakljucenihVprasanj > 0" class="btn btn--primary-fill" @click="$emit('change', sklopIndex)">Nadaljuj</v-btn>
            <!-- <v-btn v-else-if="trainingStore.Sklopi[sklopIndex!].DateCompleted || trainingStore.Sklopi[sklopIndex!].Successful" class="btn btn--primary-fill" @click="$emit('change', sklopIndex)">Ponovno opravi</v-btn> -->
            <!-- <v-btn v-if="trainingStore.Sklopi[sklopIndex!].DateCompleted" class="btn btn--primary-fill" @click="$emit('change', sklopIndex)">Ponovno opravi</v-btn> -->


            <!-- Steps -->
            <div class="d-flex align-center ga-2 "> 
                <img src="@assets/images/pages/trainings/icon-trainings-completed.svg" alt="Opravljeno"/>
                <div v-if="trainingStore.Sklopi[sklopIndex!].DateCompleted || trainingStore.Sklopi[sklopIndex!].Successful"
                class="font-weight-600">{{ trainingStore.Sklopi[sklopIndex!].StVprasanj }}/{{ trainingStore.Sklopi[sklopIndex!].StVprasanj }} korakov</div>
                
                <div v-else 
                class="font-weight-600">{{ trainingStore.Sklopi[sklopIndex!].ZakljucenihVprasanj }}/{{ trainingStore.Sklopi[sklopIndex!].StVprasanj }} korakov</div>
                
                
            </div>

        </div>

    </div>

</template>

<script setup lang="ts">
    import { useTrainingStore } from "@/app/store/app/user-center-trainings/store";

    const props = defineProps({
        sklopIndex: Number
    })

    const trainingStore = useTrainingStore();

</script>